export const toTrainCase = str => str.replace(' ', '-').toLowerCase();



// WEBPACK FOOTER //
// ./src/utilities/casing.js